import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Input } from 'antd';
const { TextArea } = Input;
export const FormTextArea = ({ name, label, isRequired = false, placeholder = '', disabled = false, readOnly = false, maxLength = 500, showCounter = false, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive, rows = 3, value, onChange, ...props }) => {
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Trường ${label ?? 'này'} không được để trống!` }] : []),
        ...rules
    ];
    const handleChange = (e) => {
        if (onChange)
            onChange(e);
    };
    const textAreaElement = (_jsx(TextArea, { ...props, placeholder: disabled || readOnly ? ' ' : placeholder || `Nhập ${label?.toLowerCase() || ''}...`, disabled: disabled, readOnly: readOnly, bordered: !readOnly, maxLength: maxLength, showCount: showCounter, rows: rows, style: isRow ? { flex: 1 } : undefined, value: value, onChange: handleChange }));
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    return (_jsx(Col, { ...colProps, children: _jsx(Form.Item, { label: isRow ? undefined : label, name: name, rules: validationRules, hidden: hidden, className: className, children: isRow ? (_jsxs("div", { style: { display: 'flex', alignItems: 'flex-start', gap: 8 }, children: [_jsxs("label", { style: {
                            minWidth: '20%',
                            fontWeight: 500,
                            marginBottom: 0,
                            whiteSpace: 'nowrap',
                            paddingTop: 6
                        }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] }), textAreaElement] })) : (textAreaElement) }) }));
};
